const appGlobalProps = global.appGlobalProps || {}

export const locale = (document.documentElement && document.documentElement.lang) ? document.documentElement.lang : 'en-us'
export const location = locale.toLocaleLowerCase()
export const language = location.split('-')[0]
export const region = location.split('-')[1]

export const contentApi = process.env.VUE_APP_CONTENT_API
export const loyaltyApi = process.env.VUE_APP_LOYALTY_API
export const zimbaApi = process.env.VUE_APP_ZIMBA_API
export const assetsUrl = appGlobalProps.assetsUrl || process.env.VUE_APP_ASSETS_URL
export const hasUrgentPressReleases = appGlobalProps.hasUrgentPressReleases

export const tridionLabels = window.tridionLabels || {}
export const maxTopics = 3

export const colors = {
  pagination: {
    button: '#B1281E',
    buttonDisabled: '#E0E0E0'
  }
}

export const defaultPressPageSize = 15
export const defaultPressPageOffset = 1
